import React from 'react'
import moment from 'moment'
import Table from '../TableComponent'
import RoomRow from '../RoomRowComponent'
import LoadingScreen from '../LoadingScreenComponent'
import formatPrice from '../../utils/formatPrice'

import Api from '../../services/ApiService'

export default class StepOneComponent extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            rooms: [],
            loadingScreen: {
                isLoading: false,
                text: 'Henter depotrum...'
            }
        }
    }

    componentDidMount() {
        Api.getStorageRooms(this.props.location_id)
        .then(data => {
            let rooms = data.map(room => {
                return {
                    resource_id: room.resource_id,
                    place: room.datafield2,
                    available: room.booking_releasedate === null ? true : moment().diff(room.booking_releasedate, 'days') > 0,
                    dateAvailable: room.booking_releasedate
                        ? room.booking_releasedate
                        : null,
                    price: formatPrice(room.price),
                    size: room.datafield1 === null ? 'Ukendt' : room.datafield1,
                    dimensions: {
                        width: room.width ? room.width : '?',
                        depth: room.depth ? room.depth : '?',
                        height: room.height ? room.height : '?'
                    },
                    max_booking_time: room.max_booking_time || 14 
                }
            })

            this.setState({
                loadingScreen: {
                    isLoading: false
                },
                rooms
            })
        })
        .catch(error => {
            this.setState({
                loadingScreen: {
                    text: 'Kan ikke få forbindelse til serveren.',
                    isLoading: true
                }
            })
        })
    }

    render () {
        let { rooms } = this.state
        let { loadingScreen } = this.state
        
        if (loadingScreen.isLoading) {
            return <LoadingScreen text={loadingScreen.text} height="300" />
        } else {
            if (rooms.length === 0) {
                return <p>Ingen ledige depotrum</p>
            }
            
            return (
                <Table>
                    <tbody>
                        {rooms
                            .sort((a, b) => a.size - b.size)
                            .map(room => (
                                <RoomRow
                                    key={room.resource_id}
                                    room={room}
                                    onClick={() => this.props.onSelectRoom(room)}
                                />
                            ))}
                    </tbody>
                </Table>
            )
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/steps/StepOneComponent.jsx